import CognitoContext, { ICognitoContext } from './CognitoContext';
import { useContext } from 'react';

const useCognito = (context = CognitoContext): ICognitoContext =>
  useContext(context);

export default useCognito;
